import { render, staticRenderFns } from "./customerAdd.vue?vue&type=template&id=e7dd1f10&"
import script from "./customerAdd.vue?vue&type=script&lang=js&"
export * from "./customerAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports